import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";


const API_URL = process.env.REACT_APP_API_URL
const API_KEY = process.env.REACT_APP_API_KEY
export const trainersApi = createApi({
    reducerPath: "trainersApi",
    baseQuery: fetchBaseQuery({ baseUrl: API_URL}),
    endpoints: (builder) => ({
        getTrainerDetails: builder.query({
            query: ({id, lang}) => ({
                method: "GET",
                url: `trainer-detail/${id}`,
                headers: {
                    "api-key": API_KEY,
                    "X-localization": lang
                }
            })
        })
    })
})

export const {useGetTrainerDetailsQuery} = trainersApi